import React from "react";
import { Route, Routes } from "react-router-dom";
import { Map } from "../pages";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Map />} />
    </Routes>
  );
};

export default Router;
